export default __webpack_public_path__ + "static/media/landcargo.38efab3d.svg";